import Vuex from 'vuex';
import Vue from 'vue';
Vue.use(Vuex);



import mutations from './mutations';
const store = new Vuex.Store({
    state: {
      hasBar: true,
      barFixed:true,
      windowInnerHeight: window.innerHeight,
      radio:null,
      chooseGifts:{},
      code:'',
      openid:""
    },

    mutations: {
      ...mutations
    }
  })

export default store